<div [class]="'main c11n-card c11n-card--density-medium c11n-card--color-'+cardColor">
    <ng-content></ng-content>
</div>